import { createAction } from '@reduxjs/toolkit'

export const setBalanceData = createAction<any>('balances/setBalanceData')
